import { ChevronLeftIcon, ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid'
import { useNavigate } from 'react-router-dom';

const pages = [
    { name: 'Projects', href: '#', current: false },
    { name: 'Project Nero', href: '#', current: true },
]

export default function Breadcrumb({ pages }) {

    const navigate = useNavigate();
    return (
        <div>
            <nav aria-label="Back" className="sm:hidden">
                <a href="#" className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                    <ChevronLeftIcon aria-hidden="true" className="-ml-1 mr-1 size-5 shrink-0 text-gray-400" />
                    Back
                </a>
            </nav>
            <nav aria-label="Breadcrumb" className="hidden sm:flex">
                <ol role="list" className="flex items-center space-x-4">
                    {pages.map((page, index) => (
                        <li key={page.name}>
                        <div className="flex items-center">
                            {index > 0 && <ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />}  
                            <a onClick={() => navigate(page.href)} className={`${index === 0 ? 'ml-0' : 'ml-4'} text-sm font-medium text-gray-500 hover:text-gray-700 cursor-pointer`}>
                                {page.name}
                            </a>
                        </div>
                    </li>
                    ))}
                </ol>
            </nav>
        </div>
    )
}
